import { render, staticRenderFns } from "./JaarverslagenListNL.vue?vue&type=template&id=730c5b35&scoped=true"
import script from "./JaarverslagenListNL.vue?vue&type=script&lang=ts"
export * from "./JaarverslagenListNL.vue?vue&type=script&lang=ts"
import style0 from "./JaarverslagenListNL.vue?vue&type=style&index=0&id=730c5b35&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "730c5b35",
  null
  
)

export default component.exports